module.exports = __webpack_public_path__ + "img/1-13.469f6faf.jpg";